import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import {useParams} from "react-router";
import adminStore from "../../storage/AdminStore";
import CompanyEdit from "../CompanyEdit";


const EditCompany = () => {
  const { id } = useParams();

  useEffect(() => {
    adminStore.company.getForEdit(id)
  }, [id])

  return (
    <CompanyEdit company={adminStore.company} redirect={'/admin/companies'}/>
  )
}

export default observer(EditCompany);